import { render, staticRenderFns } from "./DDReduceMonthlyAmount.vue?vue&type=template&id=d610e7d4&scoped=true"
import script from "./DDReduceMonthlyAmount.vue?vue&type=script&lang=js"
export * from "./DDReduceMonthlyAmount.vue?vue&type=script&lang=js"
import style0 from "./DDReduceMonthlyAmount.vue?vue&type=style&index=0&id=d610e7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d610e7d4",
  null
  
)

export default component.exports